import { config } from '../config';
import { useQuery } from '@tanstack/react-query';
import { SpaPropsResponse } from '@ab/ams-school-api/types/private/v1';

import { request } from '../lib/useRequest';

export type AppProps = {
  oauth: {
    authority?: string;
    clientId: string;
    logoutUri?: string;
    issuer?: string;
    audience?: string;
  };
  rum?: SpaPropsResponse['dashboardMonitor'];
};

export function useAppProps() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['v1_spa_props'],
    queryFn: async (): Promise<AppProps> => {
      const response = await request<SpaPropsResponse>(`${config.apiHost}/private/v1/spa_props`, {
        method: 'GET',
        isExpectedResponse,
      });

      return {
        oauth: {
          authority: response.authority,
          clientId: response.clientId,
          logoutUri: response.logoutUri,
          issuer: response.issuer,
          audience: response.audience,
        },
        rum: response.dashboardMonitor,
      };
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
  });

  return {
    appProps: data,
    isAppPropsError: isError,
    isAppPropsLoading: isLoading,
  };
}

function isExpectedResponse(res: unknown): res is SpaPropsResponse {
  return Boolean(res && typeof res === 'object');
}
